import React from 'react'

const IconAddLink= ({fillColor, style, ...props}) => {
  return (
   <svg {...props} xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
      <path d="M680-160v-120H560v-80h120v-120h80v120h120v80H760v120h-80ZM440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm560-40h-80q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480Z"/>
   </svg>
  )
}
export default IconAddLink 